import { useEffect, useState } from "react";
import { Image } from "../../../Image/Image";
import './FicheTrainer.scss';

export const FicheTrainer = (props) => {

    const [bodyItems, setBodyItems] = useState(null);

    useEffect(() => {
        let items = props.processFicheItems(props.data.body.items);
        setBodyItems(items);
    }, [JSON.stringify(props.data.body)]);

    return <div class="c-fiche no-link c-fiche-trainer" data-aos="fade-up">
        <div>
            <div class="image">
                {
                    props.data.image && <Image className="ufp-athlete" src={props.data.image.url} alt={props.data.title} />
                }
            </div>
            <header className="c-fiche__header">
                <h2 className="title">
                    {props.data.title}
                </h2>
                <p>
                    <span>
                        {props.data.text}
                    </span>
                </p>
            </header>
            <div className="c-fiche__body">
                <ul>
                    {bodyItems}
                </ul>
            </div>
        </div>
    </div>
}